import { Component, Input, OnChanges } from '@angular/core';

import { OembedService } from '../../services/oembed.service';

@Component({
  selector: 'app-embed-video',
  templateUrl: './embed-video.component.html',
  styleUrls: ['./embed-video.component.scss'],
})
export class EmbedVideoComponent implements OnChanges {
  @Input() videoUrl?: string;
  @Input() maxWidth = 400;
  @Input() maxHeight = 300;

  constructor(private readonly oembedService: OembedService) {}

  videoHtml?: string | null;

  ngOnChanges(): void {
    this.oembedService
      .getOembedVideo(this.videoUrl, this.maxWidth, this.maxHeight)
      .then((html) => (this.videoHtml = html));
  }
}
